export default "__VITE_ASSET__eb89b187__"